export const TEXT_TYPES_CODES = {
  ORDINARY: '1',
  ABBREVIATED: '2',
  SHORT: '3',
  EXPLANATORY: '4',
  BRIEF: '5',
  MEDIUM: '6',
  REGULAR_WITH_VALUE: '7',
  ADDITIONAL_SHORT: '8',
  SHORT_EXPLANATORY: '9',
  LEGALS_EXPLANATORY: '10'
};

export const TITLE_MAX = "max";
export const TITLE_TV = "televisión";
export const TITLE_UNLIMITED = "ilimitado";